import React from "react";
import {Tabs} from "antd";
import {ChangePasswordForm} from "./ChangePassword";

const TabPane = Tabs.TabPane;


export class Layout extends React.Component {
    render() {
        return (
            <div id="main-content">
                <div className="container-fluid">
                    <div className="block-header">
                        <div className="row clearfix">
                            <div className="col-12">
                                <h3 className="main-heading">Settings</h3>
                            </div>
                        </div>
                        <div className="row clearfix">
                            <div className="col-12 setting-tabs">
                                <Tabs defaultActiveKey="1" tabPosition={"left"}>
                                    <TabPane tab="Change Password" key="1">
                                        <ChangePasswordForm/>
                                    </TabPane>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/settings/Layout.jsx